const Divider = ({ className }) => <hr className={`border-border/10 my-5 ${className}`} />;

export default Divider;
